import * as authService from '../../core/services/auth.service'
import {
  clearStorage,
  saveOfferDocumentId,
  saveToken,
} from '../../core/services/storage.service'
import { LifecyclePresenter } from '../_components/ConnectComponent'
import { AdobeEventManager } from '../_utils/adobeAnalytics'
import { dataLayer } from '../_utils/adobeAnalytics/adobeAnalytics.conf'
import { LogInRaw, View } from './LogIn.view'

export class LogInPresenter implements LifecyclePresenter<View> {
  private view!: LogInRaw

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.formName = 'logIn'
    dataLayer.page.category.applicationStep = 'login_for_save&Retrieve'
    AdobeEventManager.emit('logIn_init', 'login_initiated')

    this.view.setInitialValues()
  }

  onLogIn = async (userId: string, localizer: string) => {
    try {
      const publicAuthObject = await authService.logIn(userId, localizer)
      saveOfferDocumentId(publicAuthObject.data.offerDocumentId)
      saveToken(publicAuthObject.data.jwtAuthToken)
      dataLayer.user.profile.profileInfo.loginState = "log_in"
      AdobeEventManager.emit('logIn_init', 'login_completed')

      authService.authUser().then(() => this.redirect())
    } catch (error) {
      if (error.response && error.response.status === 409) {
        AdobeEventManager.emit(
          'logIn_not_matching_auth',
          'application_form_error',
        )

        return this.view.showModal()
      }
    }
  }

  onHideModalHandler = () => {
    this.view.hideModal()
    clearStorage()
    this.view.props.history.push('/calculator/vehicles')
  }

  redirect = () => {
    this.view.props.history.push('/summary')
  }
}
